import React from 'react';
import './App.css';

import Gatekeeper from './Gatekeeper';
import NavBar from './components/NavBar';
import Hero from './components/Hero';
import Schedule from './components/Schedule';
import Venue from './components/Venue';
import Lodging from './components/Lodging';
import Registry from './components/Registry';
import RSVP from './components/RSVP';

function App() {
  return (
    <Gatekeeper>
      <div className="wedding-site">
        <NavBar />
        <Hero />
        <Schedule />
        <Venue />
        <Lodging />
        <Registry />
        <RSVP />
      </div>
    </Gatekeeper>
  );
}

export default App;